declare global {
    interface Window {
        _env_?: {
            REACT_APP_KEYCLOAK_URL?: string;
            REACT_APP_KEYCLOAK_REALM?: string;
            REACT_APP_KEYCLOAK_CLIENT_ID?: string;
        };
    }
}

export const KEYCLOAK_URL =
    window._env_?.REACT_APP_KEYCLOAK_URL ?? process.env.REACT_APP_KEYCLOAK_URL ?? 'http://localhost:6001';
export const KEYCLOAK_REALM =
    window._env_?.REACT_APP_KEYCLOAK_REALM ?? process.env.REACT_APP_KEYCLOAK_REALM ?? 'bindfind';
export const KEYCLOAK_CLIENT_ID =
    window._env_?.REACT_APP_KEYCLOAK_CLIENT_ID ?? process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? 'bindfind-web';
